import React from 'react';

import { RESEND_LINK } from '@personal-trainer-app/shared';
import { formatCountdown } from '@personal-trainer-app/shared/src/utils/number';

import type { ResendLinkButtonProps } from './ResendLinkButton.types';

import { Button } from '@/components/ui/Button';

/**
 * ResendLinkButton — asks for another emailed link once one was sent, locked
 * for the pause `useResendCooldown` counts down, which it shows.
 */
export function ResendLinkButton({
  remaining,
  loading = false,
  onClick,
}: ResendLinkButtonProps): React.JSX.Element {
  return (
    <Button
      variant="outline-contrast"
      size="md"
      fullWidth
      loading={loading}
      disabled={remaining > 0 || loading}
      onClick={onClick}
    >
      {remaining > 0 ? (
        // One inline run: Button lays its label out as flex, where the space
        // before the countdown would collapse between two items.
        <span>
          {RESEND_LINK} in{' '}
          <span className="font-mono">{formatCountdown(remaining)}</span>
        </span>
      ) : (
        RESEND_LINK
      )}
    </Button>
  );
}

export default ResendLinkButton;
